import { render, staticRenderFns } from "./TeacherDetail.vue?vue&type=template&id=7eb558e2&scoped=true&"
import script from "./TeacherDetail.vue?vue&type=script&lang=js&"
export * from "./TeacherDetail.vue?vue&type=script&lang=js&"
import style0 from "./TeacherDetail.vue?vue&type=style&index=0&id=7eb558e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb558e2",
  null
  
)

export default component.exports